/** Հայաստանի մարզեր (UI lists, Խմբագրել / Ավելացնել / Ֆիլտր) */
export const AM_REGIONS = [
  'Երևան',
  'Արագածոտն',
  'Արարատ',
  'Արմավիր',
  'Գեղարքունիք',
  'Լոռի',
  'Կոտայք',
  'Շիրակ',
  'Սյունիք',
  'Վայոց Ձոր',
  'Տավուշ',
];

export const YEREVAN_DISTRICTS = [
  'Կենտրոն',
  'Արաբկիր',
  'Դավթաշեն',
  'Մալաթիա',
  'Աջափնյակ',
  'Նոր Նորք',
  'Քանաքեռ-Զեյթուն',
  'Շենգավիթ',
  'Էրեբունի',
  'Նուբարաշեն',
  'Ավան',
  'Քանաքեռ',
];
